import { css } from 'lit';

export const slideDeleteButtonStyle = css`
  .delete {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: none;
    box-shadow: 0 2px 6px hsla(0, 0%, 0%, 0.2);
    background: white;
    transition: all 0.2s;
    cursor: pointer;
    z-index: 1;
  }
  .delete.disabled {
    cursor: default;
  }
  .delete:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: white url(/images/x-thin-black.svg) 50% 50% no-repeat;
    background-size: 100% auto;
    opacity: 0.4;
  }
  @media (hover: hover) {
    .delete {
      opacity: 0;
    }
    .thumbnail-overlay:hover .delete,
    .suggestion:hover .delete,
    .media:hover .delete,
    .delete:hover {
      opacity: 1;
    }
    .thumbnail-overlay:hover .delete.disabled,
    .suggestion:hover .delete.disabled,
    .media:hover .delete.disabled,
    .delete.disabled:hover {
      opacity: 0.5;
    }
    .delete:not(.disabled):hover {
      transform: scale(1.05);
    }
    .delete:not(.disabled):hover:after {
      background: white url(/images/x-thin-orange.svg) 50% 50% no-repeat;
      background-size: 100% auto;
      opacity: 1;
    }
  }
`;
